"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsConfirmRole = void 0;
var tslib_1 = require("tslib");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var index_1 = require("../../i18n/index");
var ACCOUNTS_SET_ROLE_SUCCESS = { key: index_1.T.ACCOUNTS_SET_ROLE_SUCCESS };
var AccountsConfirmRole = /** @class */ (function (_super) {
    tslib_1.__extends(AccountsConfirmRole, _super);
    function AccountsConfirmRole(ctrl, user, role) {
        var _this = _super.call(this, {
            title: index_1.T.ACCOUNTS_SET_ROLE_TITLE,
            confirm: index_1.T.ACCOUNTS_SET_ROLE,
            success: ACCOUNTS_SET_ROLE_SUCCESS
        }) || this;
        _this.ctrl = ctrl;
        _this.user = user;
        _this.role = role;
        return _this;
    }
    Object.defineProperty(AccountsConfirmRole.prototype, "nodes", {
        get: function () {
            var role = this.role === 'root' ? 'admin' : this.role;
            return (0, index_1.Translate)(index_1.T.ACCOUNTS_SET_ROLE_CONFIRM, { username: this.user.username, role: role });
        },
        enumerable: false,
        configurable: true
    });
    AccountsConfirmRole.prototype.submit = function () {
        return this.ctrl.setUserRole(this.user, this.role);
    };
    AccountsConfirmRole.prototype.failToChange = function () {
        this.ctrl.setLoading(this.user.objectId, false);
    };
    return AccountsConfirmRole;
}(modal_form_component_1.ModalFormComponent));
exports.AccountsConfirmRole = AccountsConfirmRole;
//# sourceMappingURL=accounts.confirm.role.js.map